export default __webpack_public_path__ + "static/media/colecao.dea894b2.webp";